import { useLocation, useNavigate } from "react-router-dom";
import { useRadio } from "@/context/RadioContext";
import { mediaUrl } from "@/lib/media";
import { Play, Pause, SkipForward, X, Radio as RadioIcon } from "lucide-react";

export function RadioDock() {
  const radio = useRadio();
  const location = useLocation();
  const navigate = useNavigate();
  if (!radio?.started || !radio.track || location.pathname === "/radio") return null;
  const { track, playing, toggle, next, stop, progress } = radio;
  const avatar = mediaUrl(track.avatar);

  return (
    <div data-testid="radio-dock" className="fixed bottom-20 md:bottom-5 right-4 md:right-5 z-[60] w-[300px] bg-surface border border-line shadow-2xl shadow-ink">
      <div className="h-[3px] bg-line"><div className="h-full bg-gold transition-[width] duration-500" style={{ width: `${progress}%` }} /></div>
      <div className="flex items-center gap-3 p-3">
        <button onClick={() => navigate(`/profile/${track.user_id}`)} data-testid="dock-open-card" className="w-11 h-11 shrink-0 bg-ink border border-line overflow-hidden">
          {avatar ? <img src={avatar} alt={track.name} className="w-full h-full object-cover" /> : <RadioIcon size={16} className="m-auto mt-3 text-gold" />}
        </button>
        <button onClick={() => navigate("/radio")} data-testid="dock-expand" className="min-w-0 flex-1 text-left">
          <p className="font-heading text-sm font-bold text-cream truncate">{track.title}</p>
          <p className="font-mono text-[10px] uppercase tracking-wide text-gold truncate">{track.name} · On air</p>
        </button>
        <button onClick={toggle} data-testid="dock-play-toggle" aria-label={playing ? "Pause" : "Play"} className="w-9 h-9 shrink-0 flex items-center justify-center bg-gold text-ink hover:bg-gold-hi transition-colors">
          {playing ? <Pause size={15} /> : <Play size={15} className="ml-0.5" />}
        </button>
        <button onClick={next} data-testid="dock-next" aria-label="Next" className="w-9 h-9 shrink-0 flex items-center justify-center border border-line text-cream hover:border-gold hover:text-gold transition-colors">
          <SkipForward size={14} />
        </button>
        <button onClick={stop} data-testid="dock-close" aria-label="Stop radio" className="shrink-0 text-ash hover:text-cream p-1 transition-colors">
          <X size={15} />
        </button>
      </div>
    </div>
  );
}
